import { ValidationFailureDto } from "@api/validation-failure-dto";
import { InjectionKey, Ref } from "vue";

export default Symbol("General validation failure provide key") as InjectionKey<
	Ref<ValidationFailureDto[]>
>;
